import components from './components'
import created from './created'
import computed from './computed'
import data from './data'
import methods from './methods'
import validations from './validations'
import mounted from './mounted'

export default {
  created,
  components,
  computed,
  data,
  methods,
  validations,
  mounted,
  resourcePath: '/v1/patient/settings/profiles'
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/resources/index.js